export function convertData(row, columns) {
  const data = {};
  columns.forEach((colum) => {
    switch (colum.key) {
      default:
        data[colum.key] = `${row[colum.key] || ""}`;
        break;
    }
  });
  return {
    id: row.id,
    ...data,
  };
}

export function JSONToFile(obj, filename) {
  const blob = new Blob([JSON.stringify(obj, null, 2)], {
    type: "application/json",
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${filename}.json`;
  a.click();
  URL.revokeObjectURL(url);
}
